export default __webpack_public_path__ + "static/media/rewardBox.814b3e8e.png";